exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".top___3kWHf{\n    width: 100%;\n    height: 130px;\n    background-image:url(\"https://tsinghua-wechat-hq.oss-cn-beijing.aliyuncs.com/4341652166522.jpg\");\n    background-size: cover;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: center;\n        justify-content: center;\n}\n\n\n.title___2FMi0{\n    font-size: 19px;\n    font-weight: 500;\n    color: #222222;\n    line-height: 20px;    \n}\n\n\n.subTitle___1Us2A {\n    font-size: 18px;\n    font-weight: 500;\n    color: #9800E0;\n    line-height: 29px;\n}\n\n.bottomTitle___2oJgX{\n    font-size: 19px;\n    font-weight: 500;\n    color: #222222;\n    line-height: 20px;\n    margin-top: 20px;\n}\n\n.bottom___1f2jJ{\n    padding-left: 18px;\n    padding-right: 18px;\n  \n}\n\n.img___t2M_6{\n    width: 120px;\n    float: left;\n    /* shape-outside: circle(); */\n    margin: 0 10px 5px 0px;\n}\n\n.content___Zrass{\n    margin-top: 30px;\n}\n\n.contentP___30nyN{\n    font-size: 15px;\n    color: #222222;\n    line-height: 27px; \n    text-align:unset;\n    letter-spacing: 2px;\n}", ""]);

// exports
exports.locals = {
	"top": "top___3kWHf",
	"title": "title___2FMi0",
	"subTitle": "subTitle___1Us2A",
	"bottomTitle": "bottomTitle___2oJgX",
	"bottom": "bottom___1f2jJ",
	"img": "img___t2M_6",
	"content": "content___Zrass",
	"contentP": "contentP___30nyN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/Culture.css
// module id = 807
// module chunks = 2